import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {Menu} from "@angular/cdk/menu";
import {Spinkit} from "ng-http-loader";


@Component({
  selector: 'app-loading-content',
  templateUrl: './loading-content.component.html',
  styleUrls: ['./loading-content.component.scss'],
})
export class LoadingContentComponent implements OnInit {
  @Input() title = 'No Data';
  @Input() icon: string;
  @Input() animation = 'move-left';
  @Input() class =`my-lg-4 my-3  flex-center rounded-medium bg-white rounded-slight overflow-hidden p-5 box-shadow-faded`;
  @Input() slug = 'clear_all';
  @Output() onClickNoContent = new EventEmitter();

  menu:Menu;

  constructor(
  ) {}

  async ngOnInit() {
    // this.menu = await lastValueFrom(this.menuService.getCurrentMenu());
    // if(!this.icon) this.icon = this.menu.icon;
    // if(!this.title) this.title = 'No any ' +  this.menu.name;
  }

  protected readonly spinkit = Spinkit;
}
